import { lazy, Suspense } from 'react'

import { Route, Switch } from 'react-router'

import { DevelopmentPage } from '@webapp/pages'

const SettingsDateFormatMigrationDraft = lazy(() =>
  import('./_migrations/settings-dateformat').then(
    ({ SettingsDateFormatMigrationDraft: Draft }) => ({ default: Draft })
  )
)

export const _DevRouter = () => {
  return (
    <Switch>
      <Route path='/dev/migrations/settings-dateformat'>
        <Suspense fallback={null}>
          <SettingsDateFormatMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev' component={DevelopmentPage} />
    </Switch>
  )
}
_DevRouter.displayName = '_DevRouter'
